import React from 'react';
import { Box, Typography } from '@mui/material';
import { Info } from '@phosphor-icons/react';

export default function ConnectionRequiredMessage({
  providerName,
}: {
  providerName: string;
}) {
  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        borderRadius: 1,
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%2398A2B3FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 100,
      }}
    >
      <Info color="#98A2B3" size={32} />
      <Typography
        sx={{ fontSize: '12px', color: '#98A2B3', textAlign: 'center', mt: 1 }}
      >
        Connect above to access {providerName}.
      </Typography>
    </Box>
  );
}
